package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Portfolio_piece(
  public val id: String,
  public val title: String,
  public val subtitle: String?,
  public val body: String,
  public val links: String?,
  public val images: String?,
  public val date_start: String?,
  public val date_end: String?,
  public val project_id: String?,
  public val step_id: String?,
  public val status: String,
  public val pinned: Long,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
